export default __webpack_public_path__ + "static/media/spacemanWave.360c3743.png";